// extracted by mini-css-extract-plugin
export default {"header":"styles-module__header--qCKyi","titleContainer":"styles-module__titleContainer--_ug8U","caption":"styles-module__caption--qC4Oa"};